const ParsePrice = price => {
    return String(price).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
};

export default ParsePrice;
